import { useOverviewContext } from "@features/overview-v2/hooks";

const LEVEL_TO_LABEL = {
  campaign: "Campaign",
  adset: "Adset",
  ad: "Ad",
} as const;

interface Props {
  allwedLevel: number;
}

export const BreakdownsNotSupportedMessage = ({ allwedLevel }: Props) => {
  const {
    filters: { level },
  } = useOverviewContext();

  return (
    <div className="flex items-center text-xxs text-mars">
      <i className="fa-regular fa-exclamation-circle mr-1 text-xs" />
      This breakdown is not supported at the {LEVEL_TO_LABEL[level]} level, only
      the {allwedLevel === 1 ? "Ad" : "Ad and Adset"} level
    </div>
  );
};
